import React from "react";
import RichText from "../../../richText/RichText";
import { Row, Col } from "react-bootstrap";
import Theme from "../../../vars/ThemeOptions";
import styled from "styled-components";
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";
import { P } from "../../common/";

const Styled = {};
Styled.BodyCopy = styled(Col)`
  .dear {
    color: ${Theme.hex("blue")};
  }
`;

Styled.Signature = styled(Row)`
  padding: 5vh 0;
  max-width: 700px;
  margin: auto;
`;

const Body = ({ block, slug }) => {
  const { ceo } = useStaticQuery(graphql`
    {
      ceo: contentfulGlobal(title: { eq: "Barclay E. Berdan, FACHE" }) {
        title
        name
        logo {
          fixed(width: 251, height: 82, resizingBehavior: PAD) {
            ...GatsbyContentfulFixed_withWebp
          }
        }
      }
    }
  `);
  const { bodyCopy } = block;
  const { json } = bodyCopy ? bodyCopy : { json: null };
  return (
    <Styled.BodyCopy
      style={{ padding: "5vh", maxWidth: "700px", margin: "auto" }}
    >
      {/* {slug === "a-note-from-our-ceo" ? (
        <h3 className="dear">Dear friends,</h3>
      ) : null} */}
      <P left>
        <RichText json={json} />
      </P>
      {slug === "a-note-from-our-ceo" ? (
        <Styled.Signature
          className="flex-column"
          noGutters
          // style={{ maxWidth: 500, margin: "auto", padding: "0 10px" }}
        >
          <Col>
            <Img fixed={ceo.logo.fixed} alt={ceo.title} />
          </Col>
          <Col>{ceo.title}</Col>
          <Col>{ceo.name}</Col>
        </Styled.Signature>
      ) : null}
    </Styled.BodyCopy>
  );
};

export default Body;
